import { useMutation } from '@tanstack/react-query';

import { addUnitMapping } from './addUnitMapping';
import {
  type AddUnitMappingMutationOptions,
  type AddUnitMappingPayload,
} from './types';

/**
 * Custom hook for adding a unit mapping from an invalid UN/CEFACT unit to a valid UN/CEFACT unit.
 *
 * @returns {Object} An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Units/operation/add_unit_mapping_units_unit_mapping_post
 */
export const useMutationAddUnitMapping = (
  options?: AddUnitMappingMutationOptions,
) => {
  return useMutation({
    mutationFn: async (unitMappingData: AddUnitMappingPayload) =>
      addUnitMapping(unitMappingData),
    ...options,
  });
};
